/**
 * Reports API
 */

import { apiClient } from "./apiClient";

export const reportsAPI = {
  list: (organizationId, params = {}) =>
    apiClient.get(`/reports/org/${organizationId}/`, { params }),

  get: (organizationId, reportId) =>
    apiClient.get(`/reports/org/${organizationId}/${reportId}/`),

  create: (organizationId, payload) =>
    apiClient.post(`/reports/org/${organizationId}/`, payload),

  update: (organizationId, reportId, payload) =>
    apiClient.patch(`/reports/org/${organizationId}/${reportId}/`, payload),

  delete: (organizationId, reportId) =>
    apiClient.delete(`/reports/org/${organizationId}/${reportId}/`),

  markSeen: (organizationId, reportId) =>
    apiClient.post(`/reports/org/${organizationId}/${reportId}/seen/`),

  unseenCount: (organizationId) =>
    apiClient.get(`/reports/org/${organizationId}/unseen-count/`),
};
